'use client'

import dynamic from 'next/dynamic'

import { ProductType } from '@/types/product'

const ProductCardLogic = dynamic(() => import('@/components/Product/ProductCard/ProductCardLogic'), {
  ssr: true,
})

export default function ProductCard({ product }: { product: ProductType }) {
  return <ProductCardLogic product={product} />
}
